/** @jsxImportSource @emotion/react */
import { useTranslation } from 'react-i18next';
import useStyle from './ProductsNav.style';

const headerLinks = {
  'Home Security': '/products/home-security/',
  Cameras: '/products/cameras/',
  Environmental: '/environmental/',
};
const headerTranslationKeys: Record<keyof typeof headerLinks, string> = {
  'Home Security': 'home-security.home-security',
  Environmental: 'environmental-detectors.environmental-detectors',
  Cameras: 'cameras.cameras',
};

const products = {
  'Home Security': [
    {
      translationKey: 'home-security.alarm-panel-hub',
      name: 'Alarm Panel and Hub',
      to: '/products/alarm-panel-hub/',
    },
    {
      translationKey: 'home-security.door-sensor',
      name: 'Door Sensor',
      to: '/products/door-sensor/',
    },
    {
      translationKey: 'home-security.window-sensor',
      name: 'Window Sensor',
      to: '/products/window-sensor/',
    },
    {
      translationKey: 'home-security.motion-detector',
      name: 'Motion Detector',
      to: '/products/motion-detector/',
    },
    {
      translationKey: 'home-security.glass-break-detector',
      name: 'Glass Break Detector',
      to: '/products/glass-break-detector/',
    },
    {
      translationKey: 'home-security.key-remote',
      name: 'Key Fob',
      to: '/products/key-remote/',
    },
    {
      translationKey: 'home-security.panic-button',
      name: 'Panic Button',
      to: '/products/panic-button/',
    },
    {
      translationKey: 'home-security.siren',
      name: 'Secondary Siren',
      to: '/products/siren/',
    },
  ],
  Cameras: [
    {
      translationKey: 'cameras.indoor-camera',
      name: 'Indoor Camera',
      to: '/products/indoor-camera/',
    },
    {
      translationKey: 'cameras.outdoor-camera',
      name: 'Outdoor Camera',
      to: '/products/outdoor-camera/',
    },
    {
      translationKey: 'cameras.doorbell-camera-eufy',
      name: 'Doorbell Camera',
      to: '/products/doorbell-camera-eufy/',
    },
  ],
  Environmental: [
    {
      translationKey: 'environmental-detectors.smoke-detector',
      name: 'Smoke Detector',
      to: '/products/smoke-detector/',
    },
    {
      translationKey: 'environmental-detectors.co-detector',
      name: 'Carbon Monoxide Detector',
      to: '/products/co-detector/',
    },
    {
      translationKey: 'environmental-detectors.flood-sensor',
      name: 'Water Leak Detector',
      to: '/products/flood-sensor/',
    },
  ],
};

function groupArr(data: any[], count: number = 0) {
  var group: any[] = [];
  for (var i = 0, j = 0; i < data.length; i++) {
    if (i >= count && i % count === 0) j++;
    group[j] = group[j] || [];
    group[j].push(data[i]);
  }
  return group;
}

const ProductsNav = () => {
  const { t } = useTranslation('common', { keyPrefix: 'links' });
  const s = useStyle();

  return (
    <div css={s.container}>
      {Object.keys(products).map((key, i) => {
        const headerTranslationKey =
          headerTranslationKeys[key as keyof typeof headerLinks];
        const headerTranslation = t(headerTranslationKey, {
          defaultValue: key,
        });
        return (
          <div key={i}>
            <h5>
              <a href={`${headerLinks[key as keyof typeof headerLinks]}`}>
                {headerTranslation}
              </a>
            </h5>
            <div className="items">
              {groupArr(products[key as keyof typeof products], 3).map(
                (group, j) => {
                  return (
                    <div key={j}>
                      {group.map((product, k) => {
                        const translatedName = t(product.translationKey, {
                          defaultValue: product.name,
                        });
                        return (
                          <a href={product.to} key={k}>
                            {translatedName}
                          </a>
                        );
                      })}
                    </div>
                  );
                }
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductsNav;
